import { Component } from '@angular/core';
import { AlertController,NavController,ToastController,ModalController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { Params } from '../params';
import * as firebase from 'firebase/app';
import { GroupIngredientsPage } from './groupingredients';

@Component({
  selector: 'page-ingredients',
  templateUrl: 'ingredients.html'
})
export class IngredientsPage{
  ingredients;
  items;
  filter:string;
  constructor(
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public navCtrl: NavController
  ){
    // this.ingredientsRef = af.list('/ingredients');
    this.filter = "name";

    /* this.ingredientsRef.subscribe(x => {
      x = x.filter((item) => {return (item.deleted==undefined || !item.deleted);});
      this.items = x;
      this.ingredients = x;
    }); */

  }

  addGroup(){
      this.navCtrl.push(GroupIngredientsPage, {ing:this.ingredients});
  }

  remove(i){
    let confirm = this.alertCtrl.create({
      title: 'Eliminar',
      message: '¿Está seguro de eliminar '+i.name+'?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Si, deseo eliminarlo',
          handler: () => {
            i.deleted = true;
            i.active = false;
            i.deletedBy = Params.md5(Params.USER_DATA.email);
            /* this.ingredient = this.af.object('ingredients/'+i.key);
            this.ingredient.set(i).then(_ => {
              let toast = this.toastCtrl.create({
                message: i.name+" eliminado exitosamente",
                duration: 3000
              });
              toast.present();
            }); */
          }
        }
      ]
    });
    confirm.present();
  }

  newItem(i){
    let modal = this.modalCtrl.create(IngredientPage, {item:i});
    modal.present();
  }

  initializeItems() {
    this.items = this.ingredients;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

}
@Component({selector: 'page-ingredient', templateUrl: 'ingredient.html'})
export class IngredientPage {
  title;
  addForm: FormGroup;
  edit:boolean = false;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    private builder: FormBuilder,
    public toastCtrl: ToastController
  ) {

    this.addForm = builder.group({
      'key': ['', Validators.required],
      'name': ['', Validators.required],
      'measure': [''],
      'weight': [0],
      'netcost': [0],
      'totalcost': [0],
      'active' : [true, Validators.required]
    })

    this.title = "Nuevo Ingrediente";
    console.log(this.params.get("item"));
    if(this.params.get("item")){
      let ingredient = this.params.get("item");
      this.edit = true;
      this.title = "Editar Ingrediente";
      this.addForm = builder.group({
        'key': [ingredient["key"], Validators.required],
        'name': [ingredient["name"], Validators.required],
        'measure': [ingredient["measure"]],
        'weight': [ingredient["weight"]],
        'netcost': [ingredient["netcost"]],
        'totalcost': [ingredient["totalcost"]],
        'active': [ingredient["active"]],
      });
    }
  }


  save() {
    console.log(this.addForm.value);
    this.addForm.value.deleted = false;
    const key = Params.key_parse(this.addForm.value["key"]);
    // this.ingredient = this.db.object('ingredients/'+key);
    let msg = 'Ingrediente '+this.addForm.value.name+' creado exitosamente';

    if(this.edit){
      msg = 'Ingrediente '+this.addForm.value.name+' editado exitosamente';
      /* this.ingredient.set(this.addForm.value).then(_ => {
        let toast = this.toastCtrl.create({
          message: msg,
          duration: 3000
        });
        toast.present();
      }); */
      this.viewCtrl.dismiss();
    }else{
      firebase.database().ref('/ingredients/'+key).once('value')
        .then((snap)=> {
          if (snap.exists()) {
            let toast = this.toastCtrl.create({
              message: 'El código '+key+' ya está siendo utilizado para otro ingrediente. Utilice otro.',
              duration: 3000
            });
            toast.present();
          }else{
            /* this.ingredient.set(this.addForm.value).then(_ => {
              let toast = this.toastCtrl.create({
                message: msg,
                duration: 3000
              });
              toast.present();
            }); */

            this.viewCtrl.dismiss();
          }
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredients.ts